//@flow
import React, { Component } from 'react';
import {
  SummaryP,
  SummaryRowDiv,
  SummaryColumnDiv
} from './TableComponentStyles';

type Props = {
  data: Array<Array<string>>,
  first?: boolean
};

export default class TableColumn extends Component<Props> {
  static defaultProps = {
    data: []
  };
  render() {
    return (
      <SummaryColumnDiv>
        {this.props.data.map((item, index) => (
          <SummaryRowDiv key={index}>
            <SummaryP bold first={this.props.first}>
              {item[0]}
            </SummaryP>
            <SummaryP>{item[1]}</SummaryP>
          </SummaryRowDiv>
        ))}
      </SummaryColumnDiv>
    );
  }
}
